<script>
import speakerDetail from './speaker-detail.vue'
import channelPrivateButton from '../channel/channel-private-button.vue'

export default {
  components: { speakerDetail, channelPrivateButton },
  props: {
    contactId: {type: String, required: true},
  },

  data() {
    return {
      contact: {},
    }
  },

  computed: {
    isSpeaker() { return !!this.contact.speaker },
    hasNetworkingInfo() {
      const c = this.contact
      return !!(c.is_booth_staff || c.is_visitor || c.speaker || c.role || c.challenges
                || (c.interests && c.interests.length))
    },
  },

  created() {
    this.fetchContact()
  },
  methods: {
    contactDisplay(contact) {
      return `${contact.first_name} ${contact.last_name}`.trim() || contact.username
    },

    fetchContact() {
      let me = this
      this.$api.get(`/community-users/${this.contactId}/`, ).then(function(response){
        me.contact = response.data
      })
    },

    deleteContact() {
      let channel = this.$storage.getDirectChannel(this.contactId)
      if (!channel) return
      if (!confirm('Kontakt löschen? Alle Nachrichten werden gelöscht.')) return
      this.$chat.delete(`channels/${channel.id}/`).then(() => {
        this.$storage.observed.directChannels = this.$storage.observed.directChannels.filter(c => c.id !== channel.id)
        this.$storage.observed.contactIds = this.$storage.observed.contactIds.filter(id => id !== this.contactId)
        this.$storage.setItem('direct-channels', this.$storage.observed.directChannels)
        this.$storage.setItem('contact-ids', this.$storage.observed.contactIds)
        this.$router.back()
      })
    }
  }
}

</script>

<template>
  <div>
    <span v-if="contact.speaker">
      <speaker-detail v-if="contact.speaker" :speakerId="contact.speaker.id.toString()" :descriptionOnly="true" />
    </span>
    <span v-else>
      <div class="card mb-2 p-2">
        <img :src="contact.profile_image" class="avatar mx-auto" />
        <div class="card-body text-center">
          <h4 class="card-title mb-0">{{contactDisplay(contact)}}</h4>
          <div class="text-muted"><small>({{contact.username}})</small></div>
          <p v-if="contact.job_title" class="text-muted">
            <small>{{contact.job_title}}</small>
          </p>
          <p>{{contact.company_name}}</p>
          <div class="mb-3">
            <channel-private-button v-if="contact.uuid" :contactId="contact.uuid" ></channel-private-button>
          </div>
        </div>
      </div>
    </span>

    <div v-if="hasNetworkingInfo" class="card mb-2 p-2">
      <div class="card-body">
        <div class="d-flex flex-wrap gap-1 mb-3">
          <span v-if="isSpeaker" class="badge bg-primary">Speaker</span>
          <span v-if="contact.is_booth_staff" class="badge bg-info text-dark">Aussteller</span>
          <span v-if="contact.is_visitor" class="badge bg-secondary">Besucher</span>
        </div>

        <div v-if="contact.role" class="mb-3">
          <div class="text-muted small text-uppercase">Rolle</div>
          <div>{{ contact.role }}</div>
        </div>

        <div v-if="contact.interests && contact.interests.length" class="mb-3">
          <div class="text-muted small text-uppercase">Interessen</div>
          <div class="d-flex flex-wrap gap-1 mt-1">
            <span v-for="cat in contact.interests" :key="cat.id" class="badge bg-light text-dark border">{{ cat.name }}</span>
          </div>
        </div>

        <div v-if="contact.challenges" class="mb-1">
          <div class="text-muted small text-uppercase">Aktuelle Herausforderungen</div>
          <div>{{ contact.challenges }}</div>
        </div>
      </div>
    </div>

    <div class="text-center mt-3">
      <button @click="deleteContact" class="btn btn-outline-danger btn-sm">
        <i class="fas fa-trash"></i> Kontakt löschen
      </button>
    </div>
  </div>
</template>

<style scoped>

a { text-decoration:none}

.avatar {
  height:100px;
  width:100px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

</style>